<app-header></app-header>

<div class="container main-page">
  <div class="row margin-top-70">
    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>PPD</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'ppd'"
                (resetAllVal)="resetDropDownVal($event)"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="ppd"
                (dateSelected)="updateSelectedIepd($event)"
                (resetDateVal)="resetDateVal($event)"
              ></app-date-select>
            </td>
          </tr>
          <tr>
            <td>Published Date</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDate'"
                (resetAllVal)="resetDropDownVal($event)"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedIepd($event)"
              ></app-date-select>
            </td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectStatusTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'status'"
                [selectedOption]="DefaultselectedOptionType"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-drop-down
                type="bookStatus"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookStatus"
                (dropDownChanged)="updateSelectedDropDown($event)"
                [selectedItems]="selectedDefaultItemsStatus"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td>User Id</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="dropdownListUserId"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'userId'"
                [selectedOption]="selectedDefaultUserId"
                (resetAllVal)="resetDropDownVal($event)"
              ></app-drop-down-single-select>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedUserId"
                name="userId"
                [disabled]="disableUserIdField.toString()"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>Product ID</td>
            <td>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedproductId"
                placeholder=""
              />
            </td>
          </tr>
          <tr>
            <td>Product Type</td>
            <td>
              <app-drop-down
                type="productType"
                [settings]="dropdownSettingsProductType"
                [list]="dropdownListProductType"
                (dropDownChanged)="updateSelectedDropDown($event)"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td>Book Type</td>
            <td>
              <app-drop-down
                type="bookType"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownListBookType"
                (dropDownChanged)="updateSelectedDropDown($event)"
              ></app-drop-down>
            </td>
          </tr>
          <tr>
            <td>Publisher</td>
            <td>
              <app-drop-down
                type="publisher"
                [settings]="dropdownSettingsBookType"
                [list]="dropdownPublisherList"
                (dropDownChanged)="updateSelectedDropDown($event)"
              ></app-drop-down>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div>
  <div class="container">
    <div class="row float-right">
      <div class="col-md-4 mt-8 offset-md-8 search-dwnload-btn-bar">
        <button
          [disabled]="showSearchLoading"
          type="submit"
          class="btn btn-pkt me-1 btn-secondary"
          (click)="searchProduct()"
        >
          {{searchBtnText}}
          <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
          <span
            *ngIf="showSearchLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>

        <button
          type="submit"
          class="btn btn-pkt btn-secondary me-1"
          (click)="downloadReport()"
        >
          {{downloadBtnText}}
          <i class="bi bi-download ps-1" *ngIf="!showDownloadLoading"></i>
        </button>
        <span
          *ngIf="showDownloadLoading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>

        <button
          type="submit"
          class="btn btn-pkt btn-secondary me-1"
          (click)="clearFilters()"
        >
          Clear
          <i class="bi bi-x-circle ps-1"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="container" style="overflow-x: scroll;">
  <table
    class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
  >
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="width-10">Product ID</th>
        <th scope="col" class="width-15">CM category</th>
        <th scope="col" class="width-15">Title</th>
        <th scope="col" class="width-15">Length</th>
        <th scope="col" class="width-15">ISBN-13P</th>

        <th scope="col" class="width-15">Number of authors</th>
        <th scope="col" class="width-15">Author Names</th>
        <th scope="col" class="width-15">Number of TRs</th>
        <th scope="col" class="width-15">TR Names</th>
        <th scope="col" class="width-15">AGPM</th>
        <th scope="col" class="width-15">PPM/APPM</th>

        <th scope="col" class="width-15">BDE</th>

        <th scope="col" class="width-15">SE</th>
        <th scope="col" class="width-15">CDE</th>
        <th scope="col" class="width-15">TE</th>
        <th scope="col" class="width-15">PM</th>
        <th scope="col" class="width-15">PC</th>

        <th scope="col" class="width-15">Publisher</th>
        <th scope="col" class="width-15">Indexer</th>
        <th scope="col" class="width-15">PD</th>
        <th scope="col" class="width-15">Month</th>
        <th scope="col" class="width-15">Status</th>

        <th scope="col" class="width-15">Product Information Status</th>
        <th scope="col" class="width-15">Book Pipeline Status</th>
        <!-- <th scope="col" style="width: 15%">Maximum Date</th> -->
        <th scope="col" class="width-15">Day since Last Draft</th>
        <th scope="col" class="width-15">Chapter Number</th>

        <th scope="col" class="width-15">PD Received</th>
        <th scope="col" class="width-15">PD Accepted</th>
        <th scope="col" class="width-15">PD Accepted %</th>
        <th scope="col" class="width-15">Sent to Reviewers</th>
        <th scope="col" class="width-15">Reviewing Complete</th>
        <th scope="col" class="width-15">Chapter Backlog</th>

        <th scope="col" class="width-15">Rewrites Prepared</th>
        <th scope="col" class="width-15">FD Received</th>
        <th scope="col" class="width-15">FD Accepted</th>
        <th scope="col" class="width-15">FD Accepted %</th>
        <th scope="col" class="width-15">DEVCON1</th>

        <th scope="col" class="width-15">DEVCON2</th>
        <th scope="col" class="width-15">TECHCON</th>

        <th scope="col" class="width-15">
          Preliminary Draft made Ready for Review Date
        </th>
        <th scope="col" class="width-15">Book Project Manager</th>
        <th scope="col" class="width-15">Technical Review Editor</th>

        <th scope="col" class="width-15">Copy Editing Complete</th>

        <th scope="col" class="width-15">TE Signed off</th>
        <th scope="col" class="width-15">Proofing Complete</th>
        <th scope="col" class="width-15">PR-TE Sign Off</th>

        <th scope="col" class="width-15">Prefinal Sent Out</th>
        <th scope="col" class="width-15">Prefinal received</th>
        <th scope="col" class="width-15">Commit Date</th>
        <th scope="col" class="width-15">Revised Commit Date</th>
        <th scope="col" class="width-15">Contracted Date</th>

        <th scope="col" class="width-15">IEPD</th>
        <th scope="col" class="width-15">EPD</th>
        <th scope="col" class="width-15">ppd</th>
        <th scope="col" class="width-15">On Sale Date</th>
        <th scope="col" class="width-15">Publication Package Upload Date</th>

        <th scope="col" class="width-15">ISBN-10</th>
        <th scope="col" class="width-15">ISBN-10e</th>
        <th scope="col" class="width-15">ISBN-13e</th>
        <th scope="col" class="width-15">Assigned User</th>
        <th scope="col" class="width-15">AE</th>
        <th scope="col" class="width-15">Contracting AE</th>
        <th scope="col" class="width-15">Book Type</th>
        <th scope="col" class="width-15">Print Price(USD)</th>
        <th scope="col" class="width-15">E-Book Price(USD)</th>
        <th scope="col" class="width-15">Website category</th>
        <th scope="col" class="width-15">Commercial Priority</th>
        <th scope="col" class="width-15">Cancelled Date</th>
        <th scope="col" class="width-15">Expected Delivery Date</th>
        <th scope="col" class="width-15">Drop Dead Publication Date</th>
        <th scope="col" class="width-15">Planned Contracting Date</th>
        <th scope="col" class="width-15">Porfolio</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of Products;">
        <th scope="row">
          <a href="{{apiURL}}/#/products/record/{{product.id}}" target="_blank"
            >{{product.part_number}}</a
          >
        </th>
        <td>
          {{(product?.pkt_job_role && product.pkt_job_role.length > 0 &&
          product.pkt_job_role[0].job_role_primary.length > 0 ) ?
          product.pkt_job_role[0].job_role_primary[0].name : '' }}
        </td>
        <td>{{product.name}}</td>
        <td>{{product.length_book ?? '0'}}</td>
        <td>{{product.isbn_13}}</td>

        <td>{{product.num_author}}</td>
        <td>{{product.author_names}}</td>
        <td>{{product.num_tech_reviewer}}</td>
        <td>{{product.technical_reviewer_names}}</td>
        <td>{{product.associate_portfolio_manager_names}}</td>
        <td>{{product.publishing_product_manager_names}}</td>
        <td>{{product.business_development_executive_name}}</td>

        <td>{{product.senior_editor_names}}</td>
        <td>{{product.content_development_editor_names}}</td>
        <td>{{product.technical_editor_names}}</td>
        <td>{{product.project_manager_names}}</td>
        <td>{{product.project_coordinator_names}}</td>

        <td>{{product.publisher_names}}</td>
        <td>{{product.indexer_names}}</td>
        <td>{{product.product_designer_names}}</td>
        <td>{{product.month}}</td>
        <td>{{product.status[0]?.name}}</td>

        <td>{{product.pistatus}}</td>
        <td>{{product.book_pipeline_status}}</td>
        
        <td>{{product.day_since_last_draft}}</td>
        <td>{{product.num_chapter}}</td>

        <td>{{product.pd_received_count}}</td>
        <td>{{product.pd_accepted_count}}</td>
        <td>{{product.pd_accepted_percentage}}%</td>

        <td>{{product.pd_technical_review_start_count}}</td>
        <td>{{product.pd_technical_review_date_count}}</td>
        <td>{{product.chapter_backlog}}</td>

        <td>{{product.pd_preparing_rewrites_count}}</td>
        <td>{{product.fd_received_count}}</td>
        <td>{{product.fd_accepted_count}}</td>
        <td>{{product.fd_accepted_percentage}}%</td>
        

        <td
          *ngIf="product?.devcon?.devcon1_status == '' || product?.devcon?.devcon1_status == null; else devcon1_not_pending"
        >
          Pending
        </td>

        <ng-template #devcon1_not_pending>
          <td>
            {{product?.devcon?.devcon1_status}}
          </td>
        </ng-template>

        <td
          *ngIf="product?.devcon?.devcon2_status == '' || product?.devcon?.devcon2_status == null; else devcon2_not_pending"
        >
          Pending
        </td>

        <ng-template #devcon2_not_pending>
          <td>
            {{product?.devcon?.devcon2_status}}
          </td>
        </ng-template>

        <td
          *ngIf="product?.devcon?.techcon_status == '' || product?.devcon?.techcon_status == null; else techcon_status_not_pending"
        >
          Pending
        </td>

        <ng-template #techcon_status_not_pending>
          <td>
            {{product?.devcon?.techcon_status}}
          </td>
        </ng-template>

       

        <td>{{product.pd_accepted_count}}</td>
        <td>{{product.book_project_manager_names}}</td>
        <td>{{product.technical_reviewer_editor_names}}</td>
        <td>{{product.copy_editing_complete_count}}</td>

        <td>{{product.te_sign_off_complete_count}}</td>
        <td>{{product.proofing_complete_count}}</td>
        <td>{{product.te_checks_complete_date_count}}</td>

        <td>{{product.prefinals_sent_out_count}}</td>
        <td>{{product.prefinals_received_count}}</td>
        <td>{{product?.date?.commit_date}}</td>
        <td>{{product?.date?.revised_commit_date}}</td>
        <td>{{product?.date?.contracted_date}}</td>

        <td>{{product?.date?.iepd}}</td>
        <td>{{product?.date?.epd}}</td>
        <td>{{product?.date?.ppd}}</td>
        <td>{{product?.publishing_date}}</td>

        <td>{{product?.date?.planned_cdp_entry_date}}</td>
        <td>{{product?.isbn?.isbn_10}}</td>
        <td>{{product?.isbn?.isbn_10e}}</td>
        <td>{{product?.isbn?.isbn_13e}}</td>
        <td>
          {{product?.assigned_user?.first_name}}
          {{product?.assigned_user?.last_name}}
        </td>
        <td>{{product.acquistion_editor_names}}</td>
        <td>{{product.ae_ppm_names}}</td>
        <td>{{product.book_type}}</td>
        <td>{{product.price_usdollar}}</td>
        <td>{{product.ebookpriceusd}}</td>
        <td>{{product.website_category}}</td>
        <td>{{product.commercial_priority}}</td>
        <td>{{product?.date?.cancelled_date }}</td>
        <td>{{product?.date?.expected_delivery_date }}</td>
        <td>{{product?.product_cstm?.drop_dead_dte_c }}</td>
        <td>{{product?.date?.planned_contracting_date }}</td>
        <td>{{product?.portfolio }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>
